import { render, staticRenderFns } from "./UserListItem.vue?vue&type=template&id=222f1c24&scoped=true"
import script from "./UserListItem.vue?vue&type=script&lang=js"
export * from "./UserListItem.vue?vue&type=script&lang=js"
import style0 from "./UserListItem.vue?vue&type=style&index=0&id=222f1c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f1c24",
  null
  
)

export default component.exports